import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { pathData } from './path-data';

export const ReemaLogoComponent = (props: SvgIconProps) => {
  const viewBox = '0 0 2852 511';

  return (
    <SvgIcon {...props} viewBox={viewBox}>
      <path d={pathData} fill="currentColor" />
    </SvgIcon>
  );
};
